import { useState, useEffect, useCallback } from 'react';
import { extractWidgetName } from './utils';
import { findLastIndex } from 'lodash';
export const useActiveWidget = function (widgetConfig) {
  if (widgetConfig === void 0) {
    widgetConfig = {
      messageIndex: 0,
      onEnable: () => {},
      messages: []
    };
  }
  const {
    messageIndex = 0,
    messages,
    onEnable = () => {}
  } = widgetConfig;
  const [isLatestInstance, setIsLatestInstance] = useState(true);
  const [hasNewerInstances, setHasNewerInstances] = useState(false);
  useEffect(() => {
    if (messageIndex === undefined || !messages) {
      setIsLatestInstance(true);
      setHasNewerInstances(false);
      return;
    }
    const latestMessageIndex = findLastIndex(messages, message => message.role === 'assistant' && extractWidgetName(message) === extractWidgetName(messages[messageIndex]));
    if (latestMessageIndex === -1) {
      setIsLatestInstance(true);
      setHasNewerInstances(false);
      return;
    }
    const isLatest = messageIndex === latestMessageIndex;
    setIsLatestInstance(isLatest);
    setHasNewerInstances(!isLatest);
  }, [messageIndex, messages]);
  const makeLatest = useCallback(() => {
    setIsLatestInstance(true);
    setHasNewerInstances(false);
    onEnable();
  }, [onEnable]);
  return {
    isLatestInstance,
    hasNewerInstances,
    makeLatest
  };
};
//# sourceMappingURL=useActiveWidget.js.map